// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2XMvB","footer":"ModalUpdate_footer__1_IOu"};